import { Field, FieldArray, useFormikContext } from "formik";
import { Company, Industry } from "models/Company";
import { useEffect } from "react";
import IndustriesSelect from "./IndustriesSelect";

const IndustriesNonCustomer = () => {

    const { values, setFieldValue } = useFormikContext<Company>();

    const useBootstrapTooltip = (numRows: Number) => {
        useEffect(() => {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipTriggerList.forEach(tooltipTriggerEl => {
                new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
            });
        }, [numRows]);
    };

    useBootstrapTooltip(values.industries.length)

    const onIndustrySelected = (industry: Industry) => {

        if (industry.code !== values.mainIndustryCode) {
            let indexMainIndustry = values.industries.findIndex(x => x.code === values.mainIndustryCode);

            if (indexMainIndustry !== -1) {
                let findAlreadyExistingIndustry = values.industries.findIndex(x => x.code === industry.code);

                if (findAlreadyExistingIndustry !== -1){
                    
                    let oldMainIndustry = values.industries[indexMainIndustry];

                    setFieldValue(`industries.[${indexMainIndustry}]`, industry);
                    setFieldValue(`industries.[${findAlreadyExistingIndustry}]`, oldMainIndustry);
                    setFieldValue(`industries.[${indexMainIndustry}].isMain`, true);
                    setFieldValue('mainIndustryCode', industry.code);

                    values.industries.map((ind : Industry, index : Number) => {
                        if (index !== indexMainIndustry){
                            setFieldValue(`industries.[${index}].isMain`, false);
                        }
                    })
                    
                }
                else{
                    setFieldValue(`industries.[${indexMainIndustry}]`, industry);
                    setFieldValue(`industries.[${indexMainIndustry}].isMain`, true);
                    setFieldValue('mainIndustryCode', industry.code);

                    values.industries.map((ind : Industry, index : Number) => {
                        if (index !== indexMainIndustry){
                            setFieldValue(`industries.[${index}].isMain`, false);
                        }
                    })
                }

            }
            else{
                setFieldValue(`industries.[0]`, industry);
                setFieldValue(`industries.[0].isMain`, true);
                setFieldValue('mainIndustryCode', industry.code);

            }
        }

    }

    return (<>
        <p className="mb-5"><a href="#" className="btn btn-light border" data-bs-toggle="modal" data-bs-target="#businessCategories">Velg annen hovedbransje…</a></p>
        <h2 className="h6">{values.name} er oppført i disse bransjene hos 1881:</h2>

        <FieldArray name='industries'>
            {fieldArrayProps => {
                return (
                    <>
                        {values.industries?.length > 0 ? values.industries.map((industry, index) => {
                            return (
                                <div key={index} className="row g-2 align-items-center mb-3 cc-listing-item">
                                    <div className="col-md-10">
                                        <Field type="text" className="form-control" name={`industries.[${index}].name`} disabled></Field>
                                    </div>
                              { !industry.isMain ?     <div className="col-md-2">
                                        <div className="form-check form-check-inline">
                                            <Field disabled={industry.code === values.mainIndustryCode} type="checkbox" className="form-check-input cc-check-delete" name={`industries.[${index}].deleted`} onChange={() => {
                                                if (industry.deleted === true) {
                                                    setFieldValue(`industries.[${index}].deleted`, false);
                                                }
                                                else {
                                                    setFieldValue(`industries.[${index}].deleted`, true);
                                                }
                                            }} ></Field>
                                            <label className="form-check-label" htmlFor="deleteN-1">Slett</label>
                                        </div>
                                    <span className="cc-help" data-bs-toggle="tooltip" data-bs-title="Bedriften vil ikke lenger bli tilknyttet denne bransjen hos 1881"><i className="bi bi-question-circle"></i></span>
                                    </div> : null

                                        }
                                </div>)

                        }) : null

                        }

                    </>
                )

            }}
        </FieldArray>
        <IndustriesSelect onIndustrySelected={onIndustrySelected} />
    </>)
}



export default IndustriesNonCustomer;